import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import _ from 'lodash';
import Button from '../../../components/button';
import FormSelect from '../../../components/dropdown/formSelect';
import InputText from '../../../components/input-text/inputText';
import Heading from '../../../components/typography';
import InitialValuesForm from '../../../constants/initialValues';
import { ContentBody, ContentContainer, ContentHeader } from './signUpSteps.styled';
import {
  ParticipantSignUpService,
  VendorTermsAndConditionsSharedService,
} from '../../../services/wealthlane-customer-services';
import { useNavigate } from 'react-router-dom';
import {
  useGetSecurityQuestion,
  useGetVendorTermAndCondition,
  useWealthlaneCustomerApi,
} from '../../../hooks';
import { STEP_FOUR_VALIDATION } from '../../../utils/validations/validations';
import { PrintContent } from '../../../utils/print';
import { Agreement } from '../../../components/agreement/agreementContainer';
import CustomControlCheckBox from '../../../components/radio-button/customControlCheckBox';
import { handleOpenFile } from '../../../utils/global';

const StepFour = (): JSX.Element => {
  const { handleRequest, isLoading } = useWealthlaneCustomerApi();
  const { data: allQuestions } = useGetSecurityQuestion(handleRequest);
  const groupedQuestions = _.groupBy(allQuestions, (item) => item.category);
  const stepFourValues = window.sessionStorage.getItem('step4');
  const navigate = useNavigate();
  const step3Values = window.sessionStorage.getItem('step3');

  const { data: VendorTermAndCondition, isLoading: isLoadingVendorTermAndCondition } =
    useGetVendorTermAndCondition(handleRequest, JSON.parse(step3Values as any)?.otpToken);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  async function handleSubmit(values: any): Promise<void> {
    setIsSubmitLoading(true);
    const formValues = window.sessionStorage.getItem('step3');
    const step3Data = JSON.parse(formValues as any);

    // // Collect agreement IDs from checked checkboxes
    // const checkedAgreementIds: string[] = [];

    // if (VendorTermAndCondition) {
    //   VendorTermAndCondition.forEach((item, index) => {
    //     const checkboxName = `employedByARegisteredBrokerDealer[${index}]`;
    //     const isChecked = values[checkboxName];

    //     if (isChecked && item.id) {
    //       checkedAgreementIds.push(item.id);
    //     }
    //   });
    // }

    // // Download agreement content for each checked agreement
    // const agreementData: any[] = [];

    // if (checkedAgreementIds.length > 0) {
    //   try {
    //     const downloadPromises = checkedAgreementIds.map(async (agreementId) => {
    //       const downloadedAgreement = await handleRequest(
    //         VendorTermsAndConditionsSharedService.getApiCustomerApiVendorTermsAndConditionsDownload(
    //           agreementId
    //         )
    //       );
    //       return downloadedAgreement;
    //     });

    //     const downloadedAgreements = await Promise.all(downloadPromises);

    //     // Filter out any null/undefined results and add to agreementData
    //     downloadedAgreements.forEach((agreement) => {
    //       if (agreement) {
    //         agreementData.push({
    //           content: agreement.content,
    //           name: agreement.name,
    //         });
    //       }
    //     });
    //   } catch (error) {
    //     console.error('Error downloading agreements:', error);
    //   }
    // }

    // // Convert agreement data to Blob
    // let onboardingAgreementBlob: Blob | undefined;
    // if (agreementData.length > 0) {
    //   const agreementJson = JSON.stringify(agreementData);
    //   onboardingAgreementBlob = new Blob([agreementJson], { type: 'application/json' });
    // }

    const payload = {
      ...values,
      ...step3Data,
      OnboardingAgreement: downloadedFiles?.[0],
    };
    handleRequest(
      ParticipantSignUpService.postApiCustomerApiV2ParticipantSignupRegisterParticipantAccount(
        payload
      )
    )
      .then((response: any) => {
        if (response != null) {
          const step4 = {
            ...payload,
            ...response,
            ...values,
          };
          window.sessionStorage.setItem('step4', JSON.stringify(step4));
          navigate('/sign-up-confirm');
          setIsSubmitLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsSubmitLoading(false);
      })
      .finally(() => {
        setIsSubmitLoading(false);
      });
  }
  const [trackIds, setTrackIds] = useState<any[]>([]);
  const [downloadedFiles, setDownloadedFiles] = useState<File[]>([]);

  const handleScroll = (e: any): void => {
    const bottom = Math.abs(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight) <= 1;
    if (bottom) {
      setTrackIds((oldIds) => Array.from(new Set([...oldIds, e?.target?.id])));
    }
  };
  const onBottomReached = (id: string): void => {
    setTrackIds((oldIds) => Array.from(new Set([...oldIds, id])));
  };
  // Helper function to convert base64 to File object
  const base64ToFile = (base64: string, fileName: string): File => {
    // Decode base64 string
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Determine MIME type from file extension
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    let mimeType = 'application/octet-stream';

    if (fileExtension === 'pdf') {
      mimeType = 'application/pdf';
    } else if (['jpg', 'jpeg'].includes(fileExtension || '')) {
      mimeType = 'image/jpeg';
    } else if (fileExtension === 'png') {
      mimeType = 'image/png';
    } else if (fileExtension === 'gif') {
      mimeType = 'image/gif';
    }

    // Create and return File object
    const blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  };

  const handleImageOpen = (id: string, name: string): void => {
    handleRequest(
      VendorTermsAndConditionsSharedService.getApiCustomerApiVendorTermsAndConditionsDownload(id)
    )
      .then((data: any) => {
        // Convert base64 content to File object
        const fileObject = base64ToFile(data.content, name);

        // Add file to state
        setDownloadedFiles((prevFiles) => {
          // Check if file with same name already exists
          const fileExists = prevFiles.some((file) => file.name === name);
          if (fileExists) {
            // Replace existing file
            return prevFiles.map((file) => (file.name === name ? fileObject : file));
          } else {
            // Add new file
            return [...prevFiles, fileObject];
          }
        });

        // Still open/display the file for user
        handleOpenFile(name, data.content);
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  };

  return (
    <ContentContainer>
      <ContentHeader>
        <Heading variant={'h4'} title={'Set Up Your Security Questions'} className='title' />
      </ContentHeader>
      <ContentBody>
        <div>
          <Formik
            enableReinitialize
            initialValues={{
              ...(JSON.parse(stepFourValues as any) ?? InitialValuesForm.SignUp.stepFour),
            }}
            validationSchema={STEP_FOUR_VALIDATION}
            onSubmit={handleSubmit}>
            {({ handleChange, errors, touched, values, setFieldValue }) => {
              console.log(values, 'values');
              return (
                <Form>
                  <>
                    <div className='grid lg:grid-cols-3'>
                      <div className=''>
                        <FormSelect
                          label='Security Question 1'
                          name='securityQuestion1'
                          placeholder='Select Question'
                          containerClassName='formGroup'
                          onChange={handleChange}
                          errors={errors}
                          touched={touched}
                          options={groupedQuestions['1']}
                          values={values}
                          setFieldValue={setFieldValue}
                          required
                        />
                        <InputText
                          type='text'
                          label='Your Answer'
                          name='securityAnswer1'
                          onChange={handleChange}
                          errors={errors}
                          touched={touched}
                          required
                        />
                        <FormSelect
                          label='Security Question 2'
                          name='securityQuestion2'
                          placeholder='Select Question'
                          containerClassName='formGroup'
                          onChange={handleChange}
                          errors={errors}
                          touched={touched}
                          options={groupedQuestions['2']}
                          values={values}
                          setFieldValue={setFieldValue}
                          required
                        />
                        <InputText
                          type='text'
                          label='Your Answer'
                          name='securityAnswer2'
                          onChange={handleChange}
                          errors={errors}
                          touched={touched}
                          required
                        />
                        <FormSelect
                          label='Security Question 3'
                          name='securityQuestion3'
                          placeholder='Select Question'
                          containerClassName='formGroup'
                          onChange={handleChange}
                          errors={errors}
                          touched={touched}
                          options={groupedQuestions['3']}
                          values={values}
                          setFieldValue={setFieldValue}
                          required
                        />
                        <InputText
                          type='text'
                          label='Your Answer'
                          className='mb-0'
                          name='securityAnswer3'
                          onChange={handleChange}
                          errors={errors}
                          touched={touched}
                          required
                        />
                        {VendorTermAndCondition?.map((item, index) => (
                          <div className='gap-4 mb-2 mt-8'>
                            {item.documentContent != null && (
                              <div className='flex justify-between'>
                                {/* <Heading title={item.name} variant={'body-s'} /> */}
                                <div></div>
                                <div
                                  className='flex cursor-pointer gap-x-2'
                                  onClick={() => PrintContent(`elementRef-${index}`, '')}>
                                  <span className='material-symbols-outlined'>print</span>
                                  <Heading title={'Print'} variant={'body-s'} />
                                </div>
                              </div>
                            )}
                            {item.documentContent != null && (
                              <Agreement
                                id={`elementRef-${index}`}
                                onScroll={handleScroll}
                                content={item?.documentContent}
                                onBottomReached={onBottomReached}
                              />
                            )}
                            {/* <AgreementContainer onScroll={handleScroll}>
                            <div
                              id={`elementRef-${index}`}
                              className='text-2xl myDivToPrint'
                              dangerouslySetInnerHTML={{
                                __html: item?.documentContent as string,
                              }}></div>
                          </AgreementContainer> */}

                            <div className='flex flex-col gap-4 pl-2'>
                              <CustomControlCheckBox
                                name={`employedByARegisteredBrokerDealer[${index}]`}
                                onChange={handleChange}
                                errors={errors}
                                touched={touched}
                                setFieldValue={setFieldValue}
                                label={
                                  item.fileName == null && <div>{item.agreementStatement}</div>
                                }
                                linkLabel={
                                  item.fileName != null && (
                                    <label
                                      className={` underline text-indigo-500 cursor-pointer`}
                                      onClick={() => {
                                        handleImageOpen(item?.id as any, item?.fileName as any);
                                        // handleFileClick({ setFileClicked, fileClicked, index });
                                      }}>
                                      {item.agreementStatement}
                                    </label>
                                  )
                                }
                                disabled={
                                  !!(
                                    item.documentContent != null &&
                                    !trackIds.includes(`elementRef-${index}`)
                                  )
                                }
                                file={!(item.fileName == null)}
                                // checked={values?.employedByARegisteredBrokerDealer}
                                required
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className='mt-12'>
                      <Button
                        as='Create'
                        variant={'primary'}
                        title={'Register Account'}
                        type='submit'
                        disabled={
                          VendorTermAndCondition &&
                          VendorTermAndCondition?.length > 0 &&
                          values.employedByARegisteredBrokerDealer?.[0] !== true
                        }
                        loading={isSubmitLoading}
                      />
                    </div>
                  </>
                </Form>
              );
            }}
          </Formik>
        </div>
      </ContentBody>
    </ContentContainer>
  );
};

export default StepFour;
